import classNames from 'classnames';
import { useHasAccess } from 'lib-shared-access-control';

import Profile from 'components/profile/containers/profile';
import { CommandLauncherTopbarButton } from 'components/topbar/components/commandLauncherButton';
import { EmailTopbarButton } from 'components/topbar/components/email';
import { NotificationTopbarButton } from 'components/topbar/components/notifications';
import { SmsTopbarButton } from 'components/topbar/components/sms';
import TelephonyTopbarButton from 'components/topbar/telephony/containers/telephonyTopbarButton';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useBreakpointValue } from 'utils/mediaQuery';

import { TopbarButton } from './components/button/topbarButton';
import styles from './topBar.module.scss';

export type TopBarProps = {
  onToggleNavigation?: () => void;
};

export const TopBar = ({ onToggleNavigation }: TopBarProps): JSX.Element => {
  const isSmallLayout = useBreakpointValue(
    { base: true, md: false },
    { fallback: 'base' },
  );
  const hasReplyAccess = useHasAccess('conversation.reply');

  const { smsCompose, emailChannel, phoneChannel } = useFeatureFlag([
    'sms-compose',
    'email-channel',
    'phone-channel',
  ]);

  const rootClass = classNames(styles.root, 'print-hidden');

  return (
    <header className={rootClass}>
      <div className={styles.drawer}>
        <TopbarButton
          icon="bars"
          label="Open sidebar"
          onClick={() => onToggleNavigation?.()}
        />
      </div>

      <div className={styles.presence}>
        <Profile isSmall={!!isSmallLayout} />
      </div>

      <div className={styles.actions}>
        {<CommandLauncherTopbarButton />}
        {hasReplyAccess && smsCompose && <SmsTopbarButton />}
        {hasReplyAccess && emailChannel && <EmailTopbarButton />}
        {hasReplyAccess && phoneChannel && <TelephonyTopbarButton />}
      </div>

      <div className={styles.notifications}>
        <NotificationTopbarButton />
      </div>
    </header>
  );
};
